import { FieldSelect } from '@dixa/lib-shared-habla';
import moment from 'moment-timezone';

type TimezoneSelectorOption = { id: string; name: string };

type FieldSelectProps = FieldSelect<TimezoneSelectorOption>['props'];

type Props = Omit<FieldSelectProps, 'items'>;

const timezones = moment.tz.names();
const formattedTimezones = timezones.map((timezone: string) => {
  const offset = moment.tz(timezone).format('Z');

  return {
    id: timezone,
    name: `${timezone} (${offset})`,
  };
});

export const TimezoneSelector = ({
  className,
  input,
  label,
  meta,
  placeholder,
  required,
  ...rest
}: Props): JSX.Element => {
  return (
    <FieldSelect<TimezoneSelectorOption>
      className={className}
      input={input}
      items={formattedTimezones}
      label={label || 'Timezone'}
      meta={meta}
      placeholder={placeholder}
      required={required}
      searchable
      {...rest}
    />
  );
};
